import React from "react";
import { Table, Typography, Divider } from "antd";

//Styles
import "./Informes.scss";

export default function DetalleDeudores(props) {
  const { currentUser, closeModal, detalleModal, myNumber } = props;

  const { Title } = Typography;

  // Encabezados de la tabla de Excel Upload
  const header = [
    {
      title: "Id", //10%
      dataIndex: "trc_id",
      key: "trc_id",
      width: "3%",
    },
    {
      title: "DOCUMENTO",
      dataIndex: "trc_documento",
      key: "trc_documento",
    },
    {
      title: "NOMBRE",
      dataIndex: "trc_nombre",
      key: "trc_nombre",
    },
    {
      title: "SALDO X C",
      dataIndex: "saldo_cxc",
      key: "saldo_cxc",
      align: "right",
      width: "10%",
      render: (text, row, index) => {
        return myNumber(1, Number.parseFloat(row.saldo_cxc));
      },
    },
  ];

  return (
    <div className="upload-panel">
      <Title level={3} style={{ color: "#6A3E98", textAlign: "center" }}>
        LISTADO DE DEUDORES
      </Title>
      <Divider style={{ marginTop: 5, paddingTop: 5, marginBottom: 5 }} />
      <Table columns={header} dataSource={detalleModal} bordered />
    </div>
  );
}
